import { AttachmentModel } from '../models/attachment.model';
import { LessonModel } from '../models/lesson.model';

export interface LessonNoteAttachmentsState {
  attachmentsForClass: AttachmentModel[];
  attachmentsForTeacher: AttachmentModel[];
  attachmentsForSubstitute: AttachmentModel[];
}

export const getEmptyLessonNoteAttachments = (): LessonNoteAttachmentsState => ({
  attachmentsForClass: [],
  attachmentsForTeacher: [],
  attachmentsForSubstitute: [],
});

export const getLessonNoteAttachments = (lesson?: LessonModel | null): LessonNoteAttachmentsState => ({
  attachmentsForClass: lesson?.attachmentsForClass ?? [],
  attachmentsForTeacher: lesson?.attachmentsForTeacher ?? [],
  attachmentsForSubstitute: lesson?.attachmentsForSubstitute ?? [],
});
